export const baseUrl = "https://staging-api.utirx.com";
// export const baseUrl = "http://localhost:1337";
